import { Datepicker, Icon, Spacing, Textarea, Title } from "@sicredi/react";
import React from "react";
import "./index.scss";

interface Props {
  hasOccurrence: boolean;
  protocol: string;
  date: string;
  className?: string;
  testId?: string;
}

export const ResponseSection: React.FC<Props> = ({
  hasOccurrence,
  date,
  protocol,
  className,
  testId,
}) => {
  const formatDateTime = (date: string) => {
    const parsedDate = Datepicker.parse(date);

    if (!parsedDate) return "Não encontrado";
    return Datepicker.format(parsedDate, "dd/MM/yyyy - HH:mm:ss");
  };
  return (
    <div data-testid={testId} className={`response-section ${className}`}>
      <div className="response-section-header">
        {hasOccurrence ? (
          <Icon
            size={104}
            className="mobile-icon"
            color="red"
            name={"feedback-error"}
          />
        ) : (
          <Icon
            className="mobile-icon"
            size={104}
            color="green"
            name={"feedback-success"}
          />
        )}
        <div className="response-section-text">
          <Title className="title">
            {hasOccurrence
              ? "Este cheque possui ocorrências."
              : "Este cheque não está sustado/revogado, furtado/roubado, e/ou cancelado, até o momento da consulta."}{" "}
          </Title>
          {hasOccurrence && (
            <Title className="subtext" size="medium">
              Pode estar sustado/revogado, furtado/roubado, e/ou cancelado, até
              o momento da consulta.
            </Title>
          )}
          <Spacing appearance="medium" />
          <div className="information-section">
            <Textarea
              label="Data e hora de consulta"
              value={formatDateTime(date)}
              required
              readOnly
            />
            <Spacing appearance="small" />
            <Textarea label="Protocolo" value={protocol} required readOnly />
          </div>
        </div>
      </div>
    </div>
  );
};
